import apiClient from './client';
import { endpoints } from './endpoints';
import type { Media } from '@/types';

export const mediaService = {
  async upload(file: File, userId: string | null = null): Promise<Media | unknown> {
    const formData = new FormData();
    formData.append('file', file);
    if (userId) formData.append('uploadedBy', userId);
    const response = await apiClient.post(endpoints.media.upload, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },
  async list(filters: Record<string, unknown> = {}): Promise<Media[] | unknown> {
    const response = await apiClient.get(endpoints.media.list, { params: filters });
    return response.data;
  },
  async delete(id: string): Promise<unknown> {
    const response = await apiClient.delete(endpoints.media.delete(id));
    return response.data;
  },
};
